import { createSlice } from "@reduxjs/toolkit";
import { fetchStartupContents } from "../controller/startupContentsController";
import errorHandler from "../../utils/errorHandler";
import { startupContentsModel } from "../model/StartupContentsModel";
import { loginUser } from "../../controller/users/usersController";
import { logoutUser } from "../../slices/auth/authenticationSlice";

const initialState = {
    isLoading: false,
    isSuccess: false,
    hasAttemptedFetch: false,
    startupData: startupContentsModel,
    error: null
};

const startupContentsSlice = createSlice({
    name: 'startupContents',
    initialState,
    extraReducers: {
        [fetchStartupContents.pending]: (state) => {
            state.isLoading = true;
            state.hasAttemptedFetch = true;
            state.error = null;
        },
        [fetchStartupContents.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.startupData = payload;
            state.error = null;
        },
        [fetchStartupContents.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.error = payload;
            errorHandler(payload);
        },
        [loginUser.fulfilled]: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.hasAttemptedFetch = false;
            state.startupData = startupContentsModel;
            state.error = null;
        },
        [logoutUser]: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.hasAttemptedFetch = false;
            state.startupData = startupContentsModel;
            state.error = null;
        }
    }
});

export default startupContentsSlice.reducer;
